// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__3dQCn","additionalInfo":"AgreementModal_additionalInfo__961Ny"};